// extracted by mini-css-extract-plugin
export var image = "_j2-1";
export var imageContainer = "_j2-0";